import { useRouteResponse } from "@src/app/hooks/useRouteResponse";
import viewportState from "@src/app/stores/viewport";
import cx from "classnames";
import { useSnapshot } from "valtio";

import Byline from "../Byline/Byline";
import TranslatorCard from "../TranslatorCard/TranslatorCard";

type Props = Readonly<{
  ref?: React.RefObject<HTMLDivElement> | null;
}> &
  React.HTMLAttributes<HTMLDivElement>;

export default function ArticleAuthorBylineSection({ ref, ...props }: Props) {
  const { article } = useRouteResponse("articlePage");
  const { authors = [], translator = "" } = article || {};
  const { isDesktopView } = useSnapshot(viewportState);

  if (!authors.length && !translator.length) return null;

  const isFullWidthArticle = ["comic", "photo_story", "big_read"].includes(
    article?.displayType || "",
  );

  return (
    <div
      className={cx(
        // in mobile
        isFullWidthArticle && isDesktopView
          ? ""
          : `bg-background-secondary dark:bg-background-secondary-on-dark text-body-1 mx-3 my-4 h-fit px-3 pt-4`,
      )}
      data-testid="article-author-byline-section"
      ref={ref}
      {...props}
    >
      {authors.length > 0 && (
        <div className={cx(isFullWidthArticle ? "grid grid-cols-12" : "")}>
          {authors.map((author) => (
            <Byline
              key={author.id}
              author={author}
              size="large"
              className={cx("col-span-12 px-3 pb-4 lg:col-span-6")}
            />
          ))}
        </div>
      )}

      {translator.length > 0 && (
        <TranslatorCard translator={translator} className="mx-3 mb-4 pl-12" />
      )}
    </div>
  );
}
